import OBase from './OBase';

import * as Geometry from '../geometry';
import * as GHMath from '../../math';

export default class Random extends OBase {
  update () {
    var rangeTree = this.getIntervalObjectInput('Range');
    var numberTree = this.getFloatInput('Number');
    var seedTree = this.getFloatInput('Seed');

    var output = this.getGenericObjectOutput('Random');

    var dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(rangeTree, numberTree, seedTree);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var outTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        var path = new Geometry.GHPath(outDataTrees[0].paths[i]);
        path.add(j);

        var range = outDataTrees[0].branches[i][j];
        var number = Number(outDataTrees[1].branches[i][j]);
        var seed = Number(outDataTrees[2].branches[i][j]);
        let rnd = new GHMath.XorShift(seed);
        for (let t = 0; t < number; t++) {
          outTree.add(rnd.randFloat(range.min, range.max), path);
        }
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Random.js